import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-activity-logs-sub-menu',
  templateUrl: './activity-logs-sub-menu.component.html',
  styleUrls: ['./activity-logs-sub-menu.component.css'],
})
export class ActivityLogsSubMenuComponent implements OnInit{
subMenuItems:any = [];

  constructor(
    private readonly router:Router
  ) {
    
  }

  ngOnInit() {
    setTimeout(() => {
      let self = this;
      self.getSubMenu();
    let categoriesMenu = JSON.parse(localStorage.getItem('navigations') as any);
    console.log("p",this.subMenuItems,self.subMenuItems)
    self.subMenuItems = this.subMenuItems.filter(
      (item: any) => {
        let titleForList = item.name.toLowerCase().split(' ').join('-');
        return categoriesMenu.includes(titleForList);
        // return categoriesMenu.includes(titleForList)
        
      }
    );
    
    for(let i = 0; i <= self.subMenuItems.length;i++) {
      let titleForList = self.subMenuItems[i].name.toLowerCase().split(' ').join('-');
      console.log("c",this.subMenuItems,self.subMenuItems,titleForList)
      if(categoriesMenu.includes(titleForList)) {
        this.router.navigate([`home/activity-logs/${self.subMenuItems[i].route}`]);
        break;
      }
    }
  },0)
  
  }

  getSubMenu() {
    this.subMenuItems = [
      // {
      //   image: '',
      //   name: 'API Logs',
      //   route: 'api-logs',
      // },
      {
        image: '',
        name: 'Login Sessions',
        route: 'login-sessions',
      },
      {
        image: '',
        name: 'Callback Logs',
        route: 'callback-logs',
      },
    ];
  }
}
